import { api } from './client'
import type { PaginatedResponse } from '@/types/api'
import type { FarmYield } from '@/types/farmYield'

export function fetchYields() {
  return api.get<PaginatedResponse<FarmYield>>('farm/yields/')
}

export function createYield(payload: Partial<FarmYield>) {
  return api.post<FarmYield>('farm/yields/', payload)
}

export function updateYield(id: string, payload: Partial<FarmYield>) {
  return api.put<FarmYield>(`farm/yields/${id}/`, payload)
}

export function deleteYield(id: string) {
  return api.delete(`farm/yields/${id}/`)
}
export async function fetchYieldsByFarm(farmId: string): Promise<FarmYield[]> {
  const { data } = await api.get(`farm/yields/crop_types/?farm=${farmId}`)
  return data
}
